import React, { useEffect, useState } from "react";
import axios, { renderDoc, decryptData } from "../Axiosinstance";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Loader from "../Loader";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import * as XLSX from "xlsx";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import "bootstrap/dist/css/bootstrap.min.css";
// CHANGE import
import { baseURLdyte } from "../common";
import Button from "@mui/material/Button";

const BatchDetails = () => {
  const { batchId, intakeId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId));
  const intakeId1 = decryptData(decodeURIComponent(intakeId));
  const [batchDetails, setBatchDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [matchingSessions, setMatchingSessions] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [sessionDetails, setSessionDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [matchingBatches, setMatchingBatches] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Set the number of sessions per page
  const [intakedata, setIntakedata] = useState([]);

  // Calculate the indexes for the current page
  const indexOfLastSession = (page + 1) * rowsPerPage;
  const indexOfFirstSession = indexOfLastSession - rowsPerPage;
  const currentSessions = matchingSessions.slice(
    indexOfFirstSession,
    indexOfLastSession,
  );

  // Function to handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Function to handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchBatchDetails = async () => {
      try {
        const response = await axios.get(`batch/${batchId1}`);
        setBatchDetails(response.data);
      } catch (error) {
        console.error("Error fetching batch details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBatchDetails();
  }, [batchId1]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/intake-details/intake/${intakeId1}`);
        if (response.data) {
          setIntakedata(response.data);
          setLoading(false);
        } else {
          throw new Error("Data format is incorrect");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, [intakeId1]);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        // fetchSessions — REPLACE
        const sessionsResponse = await axios.get(`${baseURLdyte}/sessions`);
        const sessions = sessionsResponse.data?.result?.sessions;

        if (batchDetails && sessions) {
          const url = batchDetails.onlineclasslink;
          const match = url.match(/id=([a-f\d-]+)/i);

          if (match && match[1]) {
            const meetingId = match[1];

            const matchingSessions = sessions.filter(
              (session) => session.meta.room_name === meetingId,
            );

            setMatchingSessions(matchingSessions);
            console.log(matchingSessions);
          } else {
            console.warn("Meeting ID not found in onlineclasslink");
          }
        }
      } catch (error) {
        console.error("Error fetching sessions:", error);
      }
    };

    fetchSessions();
  }, [batchDetails]);

  const handleSessionButtonClick = async (sessionId) => {
    setSelectedSessionId(sessionId);
    setShowModal(true);

    try {
      const response = await axios.get(
        `${baseURLdyte}/sessions/${sessionId}/participants`,
      );
      const participantsData = response.data?.result?.participants;

      setSessionDetails(participantsData);
      console.log("hello", JSON.stringify(participantsData));
    } catch (error) {
      console.error("Error fetching session details:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const convertSecondsToMinutes = (seconds) => {
    return (seconds / 60).toFixed(2); // Round to 2 decimal places
  };

  function formatToDDMMYYYY(dateString) {
    if (!dateString) return "Invalid Date"; // Handle undefined or null input

    const date = new Date(dateString);

    if (isNaN(date)) return "Invalid Date"; // Handle invalid date strings

    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const downloadSessionDetailsToExcel = () => {
    const workbook = XLSX.utils.book_new();

    // Combine batch and session details into a single sheet
    const sheetData = [
      {
        Course: batchDetails.course || "N/A", // Default to 'N/A' if course is missing
        Intake: intakeId1 || "N/A", // Default to 'N/A' if intakeId1 is missing
        Trainers:
          Array.isArray(intakedata.trainers) && intakedata.trainers.length > 0
            ? intakedata.trainers.join(", ")
            : "N/A", // Handle case when trainers are missing or not an array

        "Course Start Date": intakedata.scheduleDateDetails?.[0]?.startDate
          ? formatToDDMMYYYY(intakedata.scheduleDateDetails[0].startDate)
          : "N/A", // Check if startDate exists

        "Course End Date":
          intakedata.scheduleDateDetails?.length > 0
            ? formatToDDMMYYYY(
                intakedata.scheduleDateDetails[
                  intakedata.scheduleDateDetails.length - 1
                ].endDate,
              )
            : "N/A", // Check if there are schedule details and get the last endDate

        Assessors:
          Array.isArray(intakedata.assessors) && intakedata.assessors.length > 0
            ? intakedata.assessors.join(", ")
            : "N/A", // Handle case when assessors are missing or not an array
      },
      {},

      ...matchingBatches.map((student, index) => {
        const participantDetails = sessionDetails.find(
          (participant) =>
            String(participant.custom_participant_id) === String(student.id),
        );
        return {
          "S.no": index + 1,
          "Display Name": student.name,
          "Joined At": participantDetails
            ? formatDate(participantDetails.joined_at)
            : "Absent",
          "Left At": participantDetails
            ? formatDate(participantDetails.left_at)
            : "N/A",
          Duration: participantDetails
            ? convertSecondsToMinutes(participantDetails.duration) + " hrs"
            : "N/A",
        };
      }),
    ];

    const worksheet = XLSX.utils.json_to_sheet(sheetData);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Session Details");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const fileName = `${selectedSessionId ? selectedSessionId : "batch"}_session_details.xlsx`;

    // Create a download link and trigger the download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  const renderSessionTable = () => {
    let validRowIndex = 0; // Counter for valid rows

    return (
      <div className="container-responsive mt-4">
        {matchingSessions.length >= 0 && (
          <Table
            striped
            bordered
            hover
            responsive
            style={{ width: "100%", tableLayout: "fixed" }}
          >
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>S.no</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Meeting Name
                </TableCell>
                {/* <TableCell>Total Participants</TableCell> */}
                <TableCell style={{ fontWeight: "bold" }}>
                  Minutes Consumed
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Starting At
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Ending At</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentSessions.map(
                (session, index) =>
                  // Check if total_participants is not 0
                  session.total_participants !== 0 && (
                    <TableRow key={session.id}>
                      <TableCell>{++validRowIndex}</TableCell>{" "}
                      {/* Increment validRowIndex for each valid row */}
                      <TableCell>{session.meeting_display_name}</TableCell>
                      {/* <TableCell>{session.total_participants}</TableCell> */}
                      <TableCell>
                        {convertSecondsToMinutes(session.minutes_consumed)} hrs
                      </TableCell>
                      <TableCell>{formatDate(session.started_at)}</TableCell>
                      <TableCell>{formatDate(session.ended_at)}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          type="Submit"
                          onClick={() => handleSessionButtonClick(session.id)}
                        >
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ),
              )}
            </TableBody>
          </Table>
        )}
        <TablePagination
          component="div"
          count={
            matchingSessions.filter(
              (session) => session.total_participants !== 0,
            ).length
          } // Adjust count based on valid rows
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    );
  };

  const renderSessionDetailsTable = () => (
    <div>
      {sessionDetails && (
        <Table
          aria-label="table"
          style={{ tableLayout: "fixed", minWidth: "600px" }}
        >
          <TableHead
            style={{
              backgroundColor: "black",
              position: "sticky",
              top: 0,
              zIndex: 1,
            }}
          >
            <TableRow>
              <TableCell style={{ width: "100%" }}>S.no</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Meeting Name</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Joined At</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Left At</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Duration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sessionDetails.map((participant, index) => (
              <TableRow key={participant.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{participant.display_name}</TableCell>
                <TableCell>{formatDate(participant.joined_at)}</TableCell>
                <TableCell>{formatDate(participant.left_at)}</TableCell>
                <TableCell>
                  {convertSecondsToMinutes(participant.duration)} hrs
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          `/registrationadvances/active/${intakeId1}`,
        );
        // const filteredBatches = response.data.filter(batch => batch.batch_id.toString() === batchId1);
        const filteredBatches = response.data;
        setMatchingBatches(filteredBatches);
        // console.log("hdghds"+filteredBatches);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, [batchId1]);

  // const fetchExternalDataFromAPI11 = async () => {
  //   try {
  //     // const response1 = await axios.get(`registrationadvances/registration/active`);
  //     const response1 = await axios.get(`/registrationadvances/active/${intakeId1}`);
  //     const externalData = response1.data;

  //     setExternalStudents(externalData);

  //     externalData.forEach(item => {
  //       if (item.scheduleDate) {
  //         const startDateForModulus0 = item.scheduleDate.find(schedule => schedule.startModulus === 0)?.startDate;
  //         const endDateForModulus5 = item.scheduleDate.find(schedule => schedule.startModulus === 5)?.endDate;

  //         if (startDateForModulus0) {
  //           console.log('Start Date for Modulus 0:', startDateForModulus0);
  //         }
  //         if (endDateForModulus5) {
  //           console.log('End Date for Modulus 5:', endDateForModulus5);
  //         }
  //       }
  //     });

  //   } catch (error) {
  //     console.error('Error fetching external data:', error);
  //   }
  // };

  return (
    <div>
      {loading && <Loader />}
      {!loading && (
        <TableContainer sx={{ maxHeight: "none" }}>
          {renderSessionTable()}
        </TableContainer>
      )}

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="fullscreen"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "30px" }}>
            Session Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sessionDetails && (
            <div>
              <Table
                aria-label="sticky table"
                style={{ tableLayout: "fixed", minWidth: "600px" }}
              >
                <TableHead
                  style={{
                    backgroundColor: "black",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  <TableRow>
                    <TableCell style={{ width: "160px", fontWeight: "bold" }}>
                      S.No
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Joined At
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Left At
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Duration
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {matchingBatches.map((student, index) => {
                    // console.log("old" + JSON.stringify(sessionDetails));
                    const participantDetails = sessionDetails
                      // .filter(participant =>) // Filter out "group_call_host"
                      .find(
                        (participant) =>
                          String(participant.custom_participant_id) ===
                            String(student.id) &&
                          participant.role == "group_call_participant",
                      );

                    // const participantDetails = sessionDetails;
                    // console.log("student" + JSON.stringify(student));
                    // console.log("new" + JSON.stringify(participantDetails));
                    return (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{student.name}</TableCell>
                        <TableCell>
                          {participantDetails
                            ? formatDate(participantDetails.joined_at)
                            : "Absent"}
                        </TableCell>
                        <TableCell>
                          {participantDetails
                            ? formatDate(participantDetails.left_at)
                            : "N/A"}
                        </TableCell>
                        <TableCell>
                          {participantDetails
                            ? convertSecondsToMinutes(
                                participantDetails.duration,
                              ) + " hrs"
                            : "N/A"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            className="primary"
            onClick={handleCloseModal}
            style={{
              background: "#ff0000",
              fontSize: "17px",
              color: "white",
              border: "none",
              padding: "8px 40px",
              borderRadius: "7px",
            }}
          >
            Close
          </button>
          <button
            className="primary"
            startIcon={<SaveAltIcon />}
            onClick={downloadSessionDetailsToExcel}
            style={{
              background: "green",
              fontSize: "17px",
              color: "white",
              border: "none",
              padding: "8px 30px",
              borderRadius: "7px",
            }}
          >
            Download
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BatchDetails;
